const admin = {
  admin: 'System admin',
  panel_title: 'Admin panel',
  system_settings: 'System settings',
  current_versions: 'Current versions',
  build_versions: 'Build versions',
  plugin_build: 'Plugin build',
  plugin_build_info: 'Here you can find the latest plugin build.',
  plugin_version: 'Plugin version',
  download_plugin_build: 'Download build',
  plugin_ui_version:
    'Plugin UI version, separate version with | if multiple version should be active.',
  plugin_ui_version_placeholder: 'Enter Plugin UI version',
  plugin_core_version:
    'Plugin CORE version, separate version with | if multiple version should be active.',
  plugin_core_version_placeholder: 'Enter Plugin CORE version',
  go_back: 'Go back',
  flags: {
    title: 'Flags',
    guest_enabled: 'Enable guest simulations and reviews',
  },
  organizations: {
    title: 'Organization management',
    list_title: 'Organizations',
    create_title: 'Create organization',
    new_organization: 'New organisation',
    manage_title: 'Manage organization',
    organization: 'Organization',
    organization_name: 'Organization name',
    organization_name_placeholder: 'Enter organization name',
    edit: 'Edit',
    back_to_list: 'Organizations',
    organization_not_found: 'This organization could not be found.',
    general_title: 'General',
    general_description:
      'Update organization details, billing period, and simulation allowance.',
    owner_email: 'Owner email',
    owner_email_placeholder: 'Search by email',
    owner_search_hint: 'Enter at least 2 characters to search.',
    no_users_found: 'No users found.',
    create: 'Create organization',
    no_organizations: 'No organizations have been created yet.',
    billing_period: 'Current period',
    period_start: 'Period start',
    period_end: 'Period end',
    period_end_error: 'Period end must be after the period start.',
    usage: 'Usage',
    simulation_limit: 'Simulation limit',
    simulations_used: 'Simulations used',
    teams: 'Teams',
    teams_count: '{{count}} teams',
    teams_title: 'Assigned teams',
    teams_description:
      'Set which existing teams belong to this organization. Teams are managed separately in team administration.',
    available_team: 'Available team',
    team_search_placeholder: 'Search by team name or ID',
    no_matching_teams: 'No matching teams found.',
    add_team: 'Assign team',
    remove_team: 'Unassign',
    no_available_teams: 'There are no unassigned teams.',
    no_teams: 'No teams are assigned to this organization.',
  },
  validation: {
    provide_plugin_ui_version: 'Plugin UI version is required',
    provide_plugin_core_version: 'Plugin CORE version is required',
    organization_name_required: 'Organization name is required',
    owner_id_required: 'Select an organization owner',
    period_start_invalid: 'Enter a valid period start date',
    period_end_invalid: 'Enter a valid period end date',
    simulation_limit_integer: 'Simulation limit must be a whole number',
    simulation_limit_min: 'Simulation limit cannot be negative',
    team_required: 'Select a team to assign',
  },
} as const;

export default admin;
